import * as Id_bs$SolvuuApi0 from "./id_bs.bs.js";
import * as Event_bs$SolvuuApi0 from "./event_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Lang_type_bs$SolvuuApi0 from "./lang_type_bs.bs.js";
var write_payload = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.string, "term", t.term),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Lang_type_bs$SolvuuApi0.write_t, "typ", t.typ),
  /* [] */
  0]]);
});
var read_payload = Atdgen_codec_runtime.Decode.make(function (json) {
  return {
    term: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("term", Atdgen_codec_runtime.Decode.string, param);
    }, json),
    typ: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("typ", Lang_type_bs$SolvuuApi0.read_t, param);
    }, json)
  };
});

function write__2(param) {
  return Atdgen_codec_runtime.Encode.list(Atdgen_codec_runtime.Encode.string, param);
}

function read__2(param) {
  return Atdgen_codec_runtime.Decode.list(Atdgen_codec_runtime.Decode.string, param);
}

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write_payload, param);
  }, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read_payload, param);
  }, param);
}

var write_info = Atdgen_codec_runtime.Encode.make(function (x) {
  var variant = x[0];

  if (variant !== 490984684) {
    if (variant >= 816044828) {
      if (variant >= 999946793) {
        return Atdgen_codec_runtime.Encode.constr1("Update", write_payload, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Create", write_payload, x[1]);
      }
    } else if (variant >= 771069884) {
      return Atdgen_codec_runtime.Encode.constr1("Eval", Atdgen_codec_runtime.Encode.make(function (x) {
        if (x[0] >= 926225260) {
          return Atdgen_codec_runtime.Encode.constr1("Step", function (param) {
            return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, Id_bs$SolvuuApi0.write_blob, param);
          }, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Job", Id_bs$SolvuuApi0.write_job, x[1]);
        }
      }), x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Dir_bindings_add", write__1, x[1]);
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Dir_bindings_del", write__2, x[1]);
  }
});
var partial_arg = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Job",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Job */
      [3704797, x]
    );
  }, Id_bs$SolvuuApi0.read_job, param);
}]],
/* :: */
[
/* tuple */
["Step",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Step */
      [926225260, x]
    );
  }, function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, Id_bs$SolvuuApi0.read_blob, param);
  }, param);
}]],
/* [] */
0]]);
var read_info = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Create",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Create */
      [816044828, x]
    );
  }, read_payload, param);
}]],
/* :: */
[
/* tuple */
["Update",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Update */
      [999946793, x]
    );
  }, read_payload, param);
}]],
/* :: */
[
/* tuple */
["Eval",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Eval */
      [771069884, x]
    );
  }, partial_arg, param);
}]],
/* :: */
[
/* tuple */
["Dir_bindings_add",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Dir_bindings_add */
      [490835266, x]
    );
  }, read__1, param);
}]],
/* :: */
[
/* tuple */
["Dir_bindings_del",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Dir_bindings_del */
      [490984684, x]
    );
  }, read__2, param);
}]],
/* [] */
0]]]]]);
var write_event = Event_bs$SolvuuApi0.write_t;
var read_event = Event_bs$SolvuuApi0.read_t;
var write__3 = Event_bs$SolvuuApi0.write_t(write_info);
var read__3 = Event_bs$SolvuuApi0.read_t(read_info);
var read_type_ = Lang_type_bs$SolvuuApi0.read_t;
var write_type_ = Lang_type_bs$SolvuuApi0.write_t;
var read_job_id = Id_bs$SolvuuApi0.read_job;
var write_job_id = Id_bs$SolvuuApi0.write_job;
var read_blob_id = Id_bs$SolvuuApi0.read_blob;
var write_blob_id = Id_bs$SolvuuApi0.write_blob;
var read_t = read__3;
var write_t = write__3;
export { read_type_, write_type_, read_payload, write_payload, read_job_id, write_job_id, read_blob_id, write_blob_id, read_info, write_info, read_event, write_event, read_t, write_t };
/* write_payload Not a pure module */